import ajax from '../../../components/ajax';
// паузы перед повторными запросами при сетевой ошибке или ошибке сервера
var RETRY_DELAYS = [1000, 3000];
export default function useProductApi(productId) {
    function request(attempt) {
        if (attempt === void 0) { attempt = 0; }
        return ajax("/api/product/".concat(productId), {})
            .then(function (response) {
            if (response.status >= 500) {
                throw new Error("Product request failed with status ".concat(response.status));
            }
            return response.json();
        })
            .catch(function (error) {
            if (attempt >= RETRY_DELAYS.length) {
                throw error;
            }
            return new Promise(function (resolve) { return setTimeout(resolve, RETRY_DELAYS[attempt]); })
                .then(function () { return request(attempt + 1); });
        });
    }
    return { request: function () { return request(); } };
}
